/**
 * Link Service - URL-encoded links only
 */

export async function createCardLink(data) {
  const encoded = encodeURIComponent(JSON.stringify({
    preferences: data.preferences,
    booking: data.booking || null
  }))
  
  return `${window.location.origin}/dist/?card=${encoded}`
}

export async function createResponseLink(data) {
  const encoded = encodeURIComponent(JSON.stringify({
    preferences: data.preferences || [],
    responses: data.responses,
    booking: data.booking || null,
    bookingResponse: data.bookingResponse,
    alternativeBooking: data.alternativeBooking
  }))
  
  return `${window.location.origin}/dist/?results=${encoded}`
}

export async function getCardData(shortCode) {
  return null
}
